import { session, getSessionIdToken } from './session'
import { usesFirebaseSession } from './session-config'

export function installSessionHttp(client) {
  client.interceptors.request.use(async config => {
    if (!usesFirebaseSession()) return config
    config.headers = config.headers || {}
    delete config.headers.Authorization
    delete config.headers.authorization
    if (config.headers.common) delete config.headers.common.Authorization
    const generation = config.__sessionGeneration ?? session.generation
    session.assertCurrent(generation)
    config.__sessionGeneration = generation
    config.headers.Authorization = `Bearer ${await getSessionIdToken()}`
    session.assertCurrent(generation)

    return config
  })
  client.interceptors.response.use(
    async response => {
      if (usesFirebaseSession())
        session.assertCurrent(response.config.__sessionGeneration)

      if (
        usesFirebaseSession() &&
        !['get', 'head', 'options'].includes(response.config.method) &&
        /\/(roles?|users?)\//.test(response.config.url)
      ) {
        await session.refreshAuthorization()
        session.assertCurrent(response.config.__sessionGeneration)
      }

      return response
    },
    async error => {
      if (!usesFirebaseSession()) throw error
      const config = error.config
      if (!config) throw error
      session.assertCurrent(config.__sessionGeneration)
      if (error.response?.status !== 401) throw error
      if (config.__sessionRetry) {
        await session.end({ reason: 'credentials' })
        throw error
      }
      try {
        await getSessionIdToken(true)
      } catch (refreshError) {
        if (
          [
            'auth/user-disabled',
            'auth/user-token-expired',
            'auth/invalid-user-token'
          ].includes(refreshError.code)
        ) {
          await session.end({ reason: 'credentials' })
        }
        throw refreshError
      }
      session.assertCurrent(config.__sessionGeneration)
      const safeRead = ['get', 'head', 'options'].includes(
        (config.method || 'get').toLowerCase()
      )
      // A write needs a documented pre-handler rejection and an idempotency contract before replay.
      if (!safeRead) throw error
      config.__sessionRetry = true

      return client(config)
    }
  )
}
